import React, { ReactElement, useState } from 'react';
import LdapItem from '../../model/LdapItem';
import SearchLdapDataComponent from './component/SearchLdapDataComponent';
import useSearchPouzivatelList from './hook/useSearchPouzivatelList';

interface Props {
  pouzivatel: LdapItem;
  setPouzivatel: (pouzivatel: LdapItem) => void;
  label: string,
}

const SearchPouzivatelList = ({ pouzivatel, setPouzivatel, label }: Props): ReactElement => {
  const [searchToken, setSearchToken] = useState(null);
  const [data, isFetched] = useSearchPouzivatelList(searchToken);

  return (
    <SearchLdapDataComponent
      isPouzivatel
      searchToken={searchToken}
      setSearchToken={setSearchToken}
      ldapItem={pouzivatel}
      setLdapItem={setPouzivatel}
      label={label}
      data={data}
      isFetched={isFetched}
    />
  );
};

export default SearchPouzivatelList;
